import { arrayIncludesAny, filterDuplicates } from '@nu-art/ts-common';
export const filterPathwaysByContextRule = (pathways, contextRules) => {
    return pathways.filter(pathway => contextRules.some(contextRule => pathwayMatchesContextRule(pathway, contextRule)));
};
export const pathwayMatchesContextRule = (pathway, contextRule) => {
    const pathwayTagIds = filterDuplicates(pathway.tagGroups.map(g => g.value).flat()) ?? [];
    if (!pathwayTagIds.length)
        return false;
    return contextRule.rules.some(rule => arrayIncludesAny(pathwayTagIds, rule.tagIds));
};
//# sourceMappingURL=utils.js.map